import CryptoJS from "crypto-js";
import PageTracker from "../../../../common/PageTrackerHelper.js";
import VueElementLoading from "vue-element-loading";
import tableTemplate from "../../common/table-template";
import AllocationPopup from "../../CommonAllocation/b-modalsTemplate";
import pendingPods from '../../common/pendingPods';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import pendingGroupIdShipments from '../../common/pendingGroupIdShipments';
import Paginate from 'vuejs-paginate';
import AllocationTableTemplate from '../../common/AllocationTable';
import {
    getHubDeliverySRListByHubID as getHubDeliverySRListByHubID,
    GetHubFlags1 as GetHubFlags2,
    GetShipmentTableDetails as GetShipmentTableDetails,
} from '../../../../../services/modules/newallocationservices.js'
import { EventBus } from '../../../../main.js';


import {
    BasicSelect
} from "vue-search-select";
export default {
    name: "FWDAllocation",
    components: {
        Paginate,
        VueElementLoading,
        DatePicker,
        "load-table-template": tableTemplate,
        BasicSelect,
        'pending-Pods': pendingPods,
        "Allocation-Popup": AllocationPopup,
        'pending-group-id-shipment': pendingGroupIdShipments,
        'load-allocation-table-template': AllocationTableTemplate
    },
    mixins: [PageTracker],
    props: {
        srList: Array,
        hubCODPendingLimit: { type: [String, Number]},
        IsPendingCODBlock: { type: [String, Boolean]},
        isRSVSr: { type: [String, Number]},
        ServiceTypeArrayList: Array,
        ServiceTypeList: Array,
        EscalationList: Array,
        ClusterList: Array,
        allocationrefreshflag: { type: [String, Number]},
    },
    data: function() {
        return {
            value: false,
            CourierCompanyID: '',
            // isRSVSr: 0,
            MobileNumber: '',
            OldUserid: '',
            SRSelectingloader: false,
            srArrayList: [],
            // srList: [],
            SrId: '',
            SrName: '',
            srItemObj: {
                value: "",
                text: ""
            },
            srLoader: '',
            loader: '<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
            showUnallocatedList: [],
            AllocatedList: [],
            isShowPendingAllocatedList: true,
            setDashboardCountTabNameType: 'pending',
            setCountSR: 0,
            setCountSVC: 0,
            srBlockFlag: true,
            svcBlockFlag: false,

            //Allocated
            // setCountSRAllocated: 0,
            // setCountSVCAllocated: 0,
            // srAllocatedBlockFlag: false,
            // svcAllocatedBlockFlag: false,
            // //Counts Pending Sr
            // setSRCountAll: 0,
            // setSRCountP0: 0,
            // setSRCountP1: 0,
            // setSRCountP2: 0,
            // setSRCountSame_route: 0,

            // //Counts Allocated Sr
            // setSRAllocatedCountAll: 0,
            // setSRAllocatedCountP0: 0,
            // setSRAllocatedCountP1: 0,
            // setSRAllocatedCountP2: 0,

            // //Count Pending Hide Show flag for SR
            // setSRCountAllFlag: false,
            // setSRCountP0Flag: false,
            // setSRCountP1Flag: false,
            // setSRCountP2Flag: false,
            // setSRCountSame_routeFlag: true,

            // //Count Allocated Hide Show flag for SR
            // setSRAllocatedCountAllFlag: false,
            // setSRAllocatedCountP0Flag: false,
            // setSRAllocatedCountP1Flag: false,
            // setSRAllocatedCountP2Flag: false,
            // setSRAllocatedCountSame_routeFlag: false,

            // //List Pending Sr
            // setSRListAll: [],
            // setSRListP0: [],
            // setSRListP1: [],
            // setSRListP2: [],
            // setSRListSame_route: [],
            // //List Allocated Sr List
            // setSRAllocatedListAll: [],
            // setSRAllocatedListP0: [],
            // setSRAllocatedListP1: [],
            // setSRAllocatedListP2: [],
            // setSRAllocatedListSame_route: [],
            // //Count Pending SVC
            // setSVCCountAll: 0,
            // setSVCCountP0: 0,
            // setSVCCountP1: 0,
            // setSVCCountP2: 0,
            // setSVCCountSame_route: 0,

            // //Count Allocated SVC
            // setSVCAllocatedCountAll: 0,
            // setSVCAllocatedCountP0: 0,
            // setSVCAllocatedCountP1: 0,
            // setSVCAllocatedCountP2: 0,
            // setSVCAllocatedCountSame_route: 0,

            // //List Pending SVC
            // setSVCListAll: [],
            // setSVCListP0: [],
            // setSVCListP1: [],
            // setSVCListP2: [],
            // setSVCListSame_route: [],
            // //List Allocated SVC
            // setSVCAllocatedListAll: [],
            // setSVCAllocatedListP0: [],
            // setSVCAllocatedListP1: [],
            // setSVCAllocatedListP2: [],
            // setSVCAllocatedListSame_route: [],

            // //Count Pending Hide Show flag for SVC
            // setSVCCountAllFlag: false,
            // setSVCCountP0Flag: false,
            // setSVCCountP1Flag: false,
            // setSVCCountP2Flag: false,
            // setSVCCountSame_routeFlag: false,

            // //Count Allocated Hide Show flag for SVC
            // setSVCAllocatedCountAllFlag: false,
            // setSVCAllocatedCountP0Flag: false,
            // setSVCAllocatedCountP1Flag: false,
            // setSVCAllocatedCountP2Flag: false,
            // setSVCAllocatedCountSame_routeFlag: false,
            //active tab show flag for Pending
            activeTabSR: "light",
            activeTabSVC: 'outline-primary',
            //active tab show flag for Allocated
            activeTabSRAllocated: "light",
            activeTabSVCAllocated: 'outline-primary',

            // //highlight active button flag pending SR
            // activeTabSRAllFlag: 'outline-primary',
            // activeTabSRP0Flag: 'outline-primary',
            // activeTabSRP1Flag: 'outline-primary',
            // activeTabSRP2Flag: 'outline-primary',
            // activeTabSRSameRouteFlag: 'outline-primary',

            // //highlight active button flag pending SVC
            // activeTabSVCAllFlag: 'outline-primary',
            // activeTabSVCP0Flag: 'outline-primary',
            // activeTabSVCP1Flag: 'outline-primary',
            // activeTabSVCP2Flag: 'outline-primary',
            // activeTabSVCSameRouteFlag: 'outline-primary',

            //Search Pending Shipment
            searchPendingShipment: '',
            showRVPPendingShipmentsList: [],

            PendingRVPTable: '',
            PendingColumns: [{
                    "label": 'Pick Assign Date',
                    "key": "shipmenttype"
                },
                {
                    "label": 'AWB | MPS',
                    "key": "misroutetype"
                },
                {
                    "label": 'Pickup Address',
                    "key": "misroutereason"
                },
                {
                    "label": 'City',
                    "key": "misroutecount"
                },
                {
                    "label": 'Pincode',
                    "key": "currenthubcity"
                },
                {
                    "label": 'Action',
                    "key": "currentaddress"
                },
            ],
            Shipmentloader: false,
            
            /* Updated Code here */
            svcPriorities: [], // dynamically filled
            srPriorities: [],
        };
    },
    filters: {
        batchCreatedDateFormat: function(date) {
            if (date == null) return ''
            return moment(date).format('DD-MM-YYYY');
        }
    },
    computed: {
        filteredTableData() {
            if (this.searchPendingShipment.trim() === '') {
                return this.showUnallocatedListFilter = [...this.showUnallocatedList];
            }
            return this.showUnallocatedListFilter = this.showUnallocatedList.filter(item =>
                item.ShippingID.toLowerCase().includes(this.searchPendingShipment.toLowerCase()) ||
                item.PickupCity.toLowerCase().includes(this.searchPendingShipment.toLowerCase()) ||
                item.CustomerAddress.toLowerCase().includes(this.searchPendingShipment.toLowerCase()) ||
                item.ShipPincode.toLowerCase().includes(this.searchPendingShipment.toLowerCase())
            );
        }
    },
    created() {
        EventBus.$off('refreshThirdPanel'),
        EventBus.$on('refreshThirdPanel',this.CommonGetTableDetails);
    },
    async mounted() {
        this.userDataKey = window.localStorage.getItem('userUniqueKey');
        var userdetailEncrypt = window.localStorage.getItem("lmaccessuserdata");
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.createdBy = userdetail.username;
        this.userid = userdetail.userid;
        this.userHubId = userdetail.hubdetails[0] == undefined ? 0 : userdetail.hubdetails[0];
        this.CommonGetDashboardCount();

        let vm = this;
        Promise.all([
                // this.GetHubFlags(vm.userHubId),
                // this.CommonGetTableDetails(),
                // this.GetDeliverySRList(vm.userHubId),
            ])
            .then((promresult) => {
                console.log('promresult ->', promresult);
            })
            .catch((err) => {
                console.log('error in page load functions', err);
            })

        const IsRVPPaperlessEncrypt = window.localStorage.getItem('IsRVPPaperless')
        const IsRVPPaperlessbytes = CryptoJS.AES.decrypt(IsRVPPaperlessEncrypt.toString(), this.userDataKey);
        const IsRVPPaperlessbytestext = IsRVPPaperlessbytes.toString(CryptoJS.enc.Utf8);
        const paperLessKey = JSON.parse(IsRVPPaperlessbytestext)

        if (paperLessKey != null && paperLessKey.trim() == "1") {
            this.IsRVPPaperless = true;
            this.deliveryOptionListPrint.splice(2, 1);
        } else {
            this.IsRVPPaperless = false;
        }
    },
    methods: {
        // GetDeliverySRList(hubid) {
        //     return new Promise((resolve, reject) => {
        //         try {
        //             this.srLoader = this.loader;
        //             this.srArrayList = [];
        //             this.srList = [];
        //             let RVPPayload = {
        //                 "usertype": "3",
        //                 "hubid": [hubid]
        //             }
        //             getHubDeliverySRListByHubID(RVPPayload, (result) => {
        //                 try {
        //                     this.srArrayList = result.data.data.results;
        //                     for (var i = 0; i < this.srArrayList.length; i++) {
        //                         this.srList.push({
        //                             value: this.srArrayList[i].userid,
        //                             text: `${this.srArrayList[i].FirstName} ${this.srArrayList[i].LastName} (${this.srArrayList[i].OldDeliveryUserOrUserId}) (${this.srArrayList[i].userid})`,
        //                             OldUserid: this.srArrayList[i].OldDeliveryUserOrUserId,
        //                             CourierCompanyID: this.srArrayList[i].CourierCompanyID,
        //                             MobileNumber: this.srArrayList[i].MobileNumber,
        //                         })
        //                     }
        //                     this.srLoader = '';
        //                     this.CommonGetTableDetails();
        //                 } catch (e) {
        //                     console.log('Error------', e);
        //                 }
        //             })
        //             resolve(true);
        //         } catch (err) {
        //             console.log('Error Logs For GetDeliverySRList', err);
        //             resolve(false);
        //         }
        //     })
        // },
        // GetHubFlags() {
        //     return new Promise((resolve, reject) => {
        //         try {
        //             let HubFlagsRVPPayload = {
        //                 "Outsourceid": 4,
        //                 "hubid": this.userHubId
        //             }
        //             GetHubFlags2(HubFlagsRVPPayload, (result) => {
        //                 if (result.data.data.code == 200) {
        //                     this.isRSVSr = result.data.data.data.IsRSVSr
        //                 } else {
        //                     this.$alertify.error(result.data.data.message)
        //                 }
        //             })
        //             resolve(true)
        //         } catch (e) {
        //             console.log('error logs..', e);
        //             resolve(true)
        //         }
        //     })
        // },
        CommonGetTableDetails() {
            this.CountLoading = true;   
            let RVPPayload = {
                "hubId": parseInt(this.userHubId),
                "type": "ofp",
                "shipmentType": "RVP",
                "requestedBy":this.createdBy,
                "requestFrom":"WEB"
            }
            if (this.SrId) {
                RVPPayload.srId = this.SrId
            }
            if (this.BucketName) {
                RVPPayload.bucket = this.BucketName
            }
            GetShipmentTableDetails(RVPPayload, async(result) => {
                // console.log("-------------result-------------" + JSON.stringify(result.data.data.svc));
                if (result.data.code == 200) {
                    this.CountLoading = false;
                    this.showUnallocatedList = [];
                    this.showAllocatedShipmentsList = [];
                    // //Pending SR list & count Reset.
                    // this.setSRListAll = this.setSRListP0 = this.setSRListP1 = this.setSRListP2 = [];
                    // this.setSRCountAll = this.setSRCountP0 = this.setSRCountP1 = this.setSRCountP2 = 0;
                    // // Pending SVC list & count Reset.
                    // this.setSVCListAll = this.setSVCListP0 = this.setSVCListP1 = this.setSVCListP2 = [];
                    // this.setSVCCountAll = this.setSVCCountP0 = this.setSVCCountP1 = this.setSVCCountP2 = 0;

                    if (this.setDashboardCountTabNameType == 'pending') {
                        let finalResult = result.data.data;
                        this.setCountSR = finalResult.sr.count;
                        this.setCountSVC = finalResult.svc.count;
                        // if (!finalResult.sr.list && this.SrId) {
                        //     this.srBlockFlag = true;
                        //     this.svcBlockFlag = false;
                        //     this.activeTabSR = 'primary';
                        //     this.activeTabSVC = 'outline-primary';

                            

                        //     // this.setSRCountP0 = (finalResult.sr.list.P0) ? finalResult.sr.list.P0.length : this.setSRCountP0;
                        //     // this.setSRCountP1 = (finalResult.sr.list.P1) ? finalResult.sr.list.P1.length : this.setSRCountP1;
                        //     // this.setSRCountP2 = (finalResult.sr.list.P2) ? finalResult.sr.list.P2.length : this.setSRCountP2;
                        //     // this.setSRCountAll = parseInt(this.setSRCountP0) + parseInt(this.setSRCountP1) + parseInt(this.setSRCountP2)
                        //     // this.setSRCountP0Flag = (this.setSRCountP0 > 0) ? true : false;
                        //     // this.setSRCountP1Flag = (this.setSRCountP1 > 0) ? true : false;
                        //     // this.setSRCountP2Flag = (this.setSRCountP2 > 0) ? true : false;
                        //     // this.setSRCountAllFlag = (this.setSRCountAll > 0) ? true : false;
                        //     // this.setSRListAll = []
                        //     // this.setSRListP0 = []
                        //     // this.setSRListP1 = []
                        //     // this.setSRListP2 = []
                        // }
                        if (this.SrId || finalResult.sr.list) {
                            this.srBlockFlag = true;
                            this.svcBlockFlag = false;
                            this.activeTabSR = 'primary';
                            this.activeTabSVC = 'outline-primary';

                            /* Updated Code here */
                            await this.updateDynamicType('sr', finalResult);
                            /* Updated Code Here */

                            // this.setSRCountP0 = (finalResult.sr.list.P0) ? finalResult.sr.list.P0.length : this.setSRCountP0;
                            // this.setSRCountP1 = (finalResult.sr.list.P1) ? finalResult.sr.list.P1.length : this.setSRCountP1;
                            // this.setSRCountP2 = (finalResult.sr.list.P2) ? finalResult.sr.list.P2.length : this.setSRCountP2;
                            // this.setSRCountAll = parseInt(this.setSRCountP0) + parseInt(this.setSRCountP1) + parseInt(this.setSRCountP2)

                            // //Show hide flag
                            // this.setSRCountP0Flag = (this.setSRCountP0 > 0) ? true : false;
                            // this.setSRCountP1Flag = (this.setSRCountP1 > 0) ? true : false;
                            // this.setSRCountP2Flag = (this.setSRCountP2 > 0) ? true : false;
                            // this.setSRCountAllFlag = (this.setSRCountAll > 0) ? true : false;

                            // //SR pending list
                            // if (finalResult.sr.list.P0) {
                            //     this.setSRListAll = [...this.setSRListAll, ...finalResult.sr.list.P0]
                            //     this.setSRListP0 = [...this.setSRListP0, ...finalResult.sr.list.P0]
                            // }
                            // if (finalResult.sr.list.P1) {
                            //     this.setSRListAll = [...this.setSRListAll, ...finalResult.sr.list.P1]
                            //     this.setSRListP1 = [...this.setSRListP1, ...finalResult.sr.list.P1]
                            // }
                            // if (finalResult.sr.list.P2) {
                            //     this.setSRListAll = [...this.setSRListAll, ...finalResult.sr.list.P2]
                            //     this.setSRListP2 = [...this.setSRListP2, ...finalResult.sr.list.P2]
                            // }

                        } else {
                            this.srBlockFlag = false;
                            this.svcBlockFlag = true;
                            this.activeTabSVC = 'primary';
                            this.activeTabSR = 'outline-primary';

                            /* Updated Code here */
                            await this.updateDynamicType('svc', finalResult);
                            /* Updated Code Here */


                            // const { P0, P1, P2 } = finalResult.svc.list;

                            // // Set SVC counts and flags
                            // this.setSVCCountP0 = P0 ? P0.length : this.setSVCCountP0;
                            // this.setSVCCountP1 = P1 ? P1.length : this.setSVCCountP1;
                            // this.setSVCCountP2 = P2 ? P2.length : this.setSVCCountP2;
                            // this.setSVCCountAll = parseInt(this.setSVCCountP0) + parseInt(this.setSVCCountP1) + parseInt(this.setSVCCountP2);

                            // //Show hide flag
                            // this.setSVCCountP0Flag = (this.setSVCCountP0 > 0) ? true : false;
                            // this.setSVCCountP1Flag = (this.setSVCCountP1 > 0) ? true : false;
                            // this.setSVCCountP2Flag = (this.setSVCCountP2 > 0) ? true : false;
                            // this.setSVCCountAllFlag = (this.setSVCCountAll > 0) ? true : false;

                            // //SVC pending List
                            // if (finalResult.svc.list.P0) {
                            //     this.setSVCListAll = [...this.setSVCListAll, ...finalResult.svc.list.P0]
                            //     this.setSVCListP0 = [...this.setSVCListP0, ...finalResult.svc.list.P0]
                            // }
                            // if (finalResult.svc.list.P1) {
                            //     this.setSVCListAll = [...this.setSVCListAll, ...finalResult.svc.list.P1]
                            //     this.setSVCListP1 = [...this.setSVCListP1, ...finalResult.svc.list.P1]
                            // }
                            // if (finalResult.svc.list.P2) {
                            //     this.setSVCListAll = [...this.setSVCListAll, ...finalResult.svc.list.P2]
                            //     this.setSVCListP2 = [...this.setSVCListP2, ...finalResult.svc.list.P2]
                            // }

                        }

                        if (finalResult.svc.list && this.SrId == '') {
                            this.changeSelected('pendingsvc', 'All')
                        } else if (finalResult.sr.list) {
                            this.changeSelected('pendingsr', 'All')
                        } else {
                            this.CountLoading = false;
                        }
                    }
                    let TrackerInfo = {
                      projectname: "Last Mile",
                      type: "Web",
                      routeurl: "api/rvpallocation/reverseshipmentlist",
                      userid: this.userid,
                      username: this.createdBy,
                      meta: {
                        event: "api-rvpallocation-reverseshipmentlist",
                        shipmentId: null,
                        hubId: this.userHubId,
                        remarks: "FrontEnd"
                      },
                    };
                    Object.assign(TrackerInfo.meta, RVPPayload);
                    this.PageTracker(TrackerInfo);
                } else if (result.data.code != 200) {
                    this.CountLoading = false;
                    this.showUnallocatedList = [];
                    console.log('No Shipments found..');
                    this.unallocatepageCount = 1
                    this.UATableLoader = false
                }

            })
        },
        CommonGetDashboardCount() {
            this.CountLoading = true;
            let RVPPayload = {
                "hubId": parseInt(this.userHubId),
                "shipmentType": "RVP"
            }
            if (this.SrId) {
                RVPPayload.srId = this.SrId
            }

        },
        changeSelected(params, subparams) {

            this.showUnallocatedList = [];
            this.showAllocatedShipmentsList = [];
            let upperType = params === 'pendingsr' ? 'SR' : 'SVC';
            if (params == 'pendingsr') {
                this.srBlockFlag = true;
                this.svcBlockFlag = false;
                this.activeTabSR = 'primary';
                this.activeTabSVC = 'outline-primary';

                // ---- Show/Hide SR Count Flags ----
                this.srPriorities.forEach(key => {
                    this[`set${upperType}Count${key}Flag`] = this[`set${upperType}Count${key}`] > 0;
                });

                // ---- Reset All Active Tab Flags ----
                this.srPriorities.forEach(key => {
                    this[`activeTab${upperType}${key}Flag`] = 'outline-primary';
                });

                // ---- Determine Selected Tab ----
                const selected = subparams || 'All';
                this[`activeTab${upperType}${selected}Flag`] = 'primary';

                // ---- Merge Corresponding List Dynamically ----
                const listKey = `set${upperType}List${selected}`;
                if (Array.isArray(this[listKey])) {
                    this.showUnallocatedList = [...this.showUnallocatedList, ...this[listKey]];
                }


                // //Show hide flag
                // this.setSRCountP0Flag = (this.setSRCountP0 > 0) ? true : false;
                // this.setSRCountP1Flag = (this.setSRCountP1 > 0) ? true : false;
                // this.setSRCountP2Flag = (this.setSRCountP2 > 0) ? true : false;
                // this.setSRCountAllFlag = (this.setSRCountAll > 0) ? true : false;

                // //Show all shipment Pending SR
                // if (subparams == 'All') {
                //     this.activeTabSRAllFlag = (subparams == 'All') ? 'primary' : 'outline-primary';
                //     this.activeTabSRP0Flag = this.activeTabSRP1Flag = this.activeTabSRP2Flag = this.activeTabSRSameRouteFlag = 'outline-primary'
                //     this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSRListAll);
                // } else if (subparams == 'P0') {
                //     this.activeTabSRP0Flag = (subparams == 'P0') ? 'primary' : 'outline-primary';
                //     this.activeTabSRAllFlag = this.activeTabSRP1Flag = this.activeTabSRP2Flag = this.activeTabSRSameRouteFlag = 'outline-primary'
                //     this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSRListP0);
                // } else if (subparams == 'P1') {
                //     this.activeTabSRP1Flag = (subparams == 'P1') ? 'primary' : 'outline-primary';
                //     this.activeTabSRAllFlag = this.activeTabSRP0Flag = this.activeTabSRP2Flag = this.activeTabSRSameRouteFlag = 'outline-primary'
                //     this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSRListP1);
                // } else if (subparams == 'P2') {
                //     this.activeTabSRP2Flag = (subparams == 'P2') ? 'primary' : 'outline-primary';
                //     this.activeTabSRAllFlag = this.activeTabSRP0Flag = this.activeTabSRP1Flag = this.activeTabSRSameRouteFlag = 'outline-primary'
                //     this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSRListP2);
                // }
            } else if (params == 'pendingsvc') {
                this.srBlockFlag = false;
                this.svcBlockFlag = true;
                this.activeTabSVC = 'primary';
                this.activeTabSR = 'outline-primary';

                // ---- Show/Hide Count Flags Dynamically ----
                this.svcPriorities.forEach(key => {
                    this[`set${upperType}Count${key}Flag`] = this[`set${upperType}Count${key}`] > 0;
                });

                // ---- Reset All Active Tab Flags ----
                this.svcPriorities.forEach(key => {
                    this[`activeTab${upperType}${key}Flag`] = 'outline-primary';
                });

                // ---- Determine Selected Tab ----
                const selected = subparams || 'All';
                this[`activeTab${upperType}${selected}Flag`] = 'primary';

                // ---- Merge Corresponding List Dynamically ----
                const listKey = `set${upperType}List${selected}`;
                if (Array.isArray(this[listKey])) {
                    this.showUnallocatedList = [...this.showUnallocatedList, ...this[listKey]];
                }

                // //Show hide flag
                // this.setSVCCountP0Flag = (this.setSVCCountP0 > 0) ? true : false;
                // this.setSVCCountP1Flag = (this.setSVCCountP1 > 0) ? true : false;
                // this.setSVCCountP2Flag = (this.setSVCCountP2 > 0) ? true : false;
                // this.setSVCCountAllFlag = (this.setSVCCountAll > 0) ? true : false;
                // this.setSVCCountSame_routeFlag = (this.setSVCCountSame_route > 0) ? true : false;

                // //Show all shipment Pending SVC
                // if (subparams == 'All') {
                //     this.activeTabSVCAllFlag = (subparams == 'All') ? 'primary' : 'outline-primary';
                //     this.activeTabSVCP0Flag = this.activeTabSVCP1Flag = this.activeTabSVCP2Flag = this.activeTabSVCSameRouteFlag = 'outline-primary'
                //     this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSVCListAll);
                // } else if (subparams == 'P0') {
                //     this.activeTabSVCP0Flag = (subparams == 'P0') ? 'primary' : 'outline-primary';
                //     this.activeTabSVCAllFlag = this.activeTabSVCP1Flag = this.activeTabSVCP2Flag = this.activeTabSVCSameRouteFlag = 'outline-primary'
                //     this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSVCListP0);
                // } else if (subparams == 'P1') {
                //     this.activeTabSVCP1Flag = (subparams == 'P1') ? 'primary' : 'outline-primary';
                //     this.activeTabSVCAllFlag = this.activeTabSVCP0Flag = this.activeTabSVCP2Flag = this.activeTabSVCSameRouteFlag = 'outline-primary'
                //     this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSVCListP1);
                // } else if (subparams == 'P2') {
                //     this.activeTabSVCP2Flag = (subparams == 'P2') ? 'primary' : 'outline-primary';
                //     this.activeTabSVCAllFlag = this.activeTabSVCP0Flag = this.activeTabSVCP1Flag = this.activeTabSVCSameRouteFlag = 'outline-primary'
                //     this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSVCListP2);
                // }
            }

            this.showUnallocatedListFilter = [...this.showUnallocatedList];
        },
        selectSR(obj) {
            this.srItemObj = {};
            this.SrId = '';
            this.SrName = '';

            // Reset counts and lists for SR
            // this.setSRListAll = [];
            // this.setSRListP0 = [];
            // this.setSRListP1 = [];
            // this.setSRListP2 = [];
            // this.setSRCountAll = this.setSRCountP0 = this.setSRCountP1 = this.setSRCountP2 = 0;


            // Set the selected SR
            this.srItemObj = obj;
            this.SrId = obj.value;
            this.SrName = obj.text;

            // Set flags for tab display
            this.srBlockFlag = false;
            this.svcBlockFlag = true;
            this.activeTabSVC = 'primary';
            this.activeTabSR = 'outline-primary';

            // this.resetSVCButtonColors()

            // // Show/hide flags based on the new SR counts
            // this.setSRCountP0Flag = this.setSRCountP0 > 0;
            // this.setSRCountP1Flag = this.setSRCountP1 > 0;
            // this.setSRCountP2Flag = this.setSRCountP2 > 0;
            // this.setSRCountAllFlag = this.setSRCountAll > 0;

            // Fetch the new SR details
            this.CommonGetTableDetails();
        },
        clearSR() {
            this.SrId = '';
            this.srItemObj = {};
            this.tripDayflag = 0;
            this.tripTitle = '';
            this.tripCreatedDate = '';
            this.searchPendingShipment = '';
            this.filteredTableData = [];
            this.PendingRVPTable = [];
            this.showUnallocatedListFilter = this.showUnallocatedList;

            this.srBlockFlag = true;
            this.svcBlockFlag = false;

            // this.setSVCCountAllFlag = false;
            // this.setSVCCountP0Flag = false;
            // this.setSVCCountP1Flag = false;
            // this.setSVCCountP2Flag = false;

            // this.setSVCAllocatedCountAllFlag = false;
            // this.setSVCAllocatedCountP0Flag = false;
            // this.setSVCAllocatedCountP1Flag = false;
            // this.setSVCAllocatedCountP2Flag = false;


            this.activeTabSR = 'outline-primary';
            this.activeTabSVC = 'outline-primary';

            this.activeTabSRAllocated = 'outline-primary';
            this.activeTabSVCAllocated = 'outline-primary';
            // this.resetSRButtonColors()

            // this.resetSVCButtonColors()

            this.CommonGetTableDetails()
        },

        // updateSRAllocatedFlags() {
        //     this.setSRAllocatedCountP0Flag = this.setSRAllocatedCountP0 > 0;
        //     this.setSRAllocatedCountP1Flag = this.setSRAllocatedCountP1 > 0;
        //     this.setSRAllocatedCountP2Flag = this.setSRAllocatedCountP2 > 0;
        //     this.setSRAllocatedCountAllFlag = this.setSRAllocatedCountAll > 0;
        // },

        // updateSVCAllocatedFlags() {
        //     this.setSVCAllocatedCountP0Flag = this.setSVCAllocatedCountP0 > 0;
        //     this.setSVCAllocatedCountP1Flag = this.setSVCAllocatedCountP1 > 0;
        //     this.setSVCAllocatedCountP2Flag = this.setSVCAllocatedCountP2 > 0;
        //     this.setSVCAllocatedCountAllFlag = this.setSVCAllocatedCountAll > 0;
        // },

        // resetSVCButtonColors() {
        //     this.activeTabSVCAllFlag = 'outline-primary'
        //     this.activeTabSVCP0Flag = 'outline-primary'
        //     this.activeTabSVCP1Flag = 'outline-primary'
        //     this.activeTabSVCP2Flag = 'outline-primary'
        //     this.activeTabSVCSameRouteFlag = 'outline-primary'
        // },

        // resetSRButtonColors() {
        //     this.activeTabSRAllFlag = 'outline-primary'
        //     this.activeTabSRP0Flag = 'outline-primary'
        //     this.activeTabSRP1Flag = 'outline-primary'
        //     this.activeTabSRP2Flag = 'outline-primary'
        //     this.activeTabSRSameRouteFlag = 'outline-primary'
        // },

        /* Updated Code here */
        updateDynamicType(type, finalResult) {
            let list = finalResult[type].list;
            let upper = type.toUpperCase();

            // Always initialize master list
            if (!this[`set${upper}ListAll`]) this.$set(this, `set${upper}ListAll`, []);

            if (list) {
                let keys = Object.keys(list);

                // Ensure priorities exist

                this[`${type}Priorities`] = [
                'All',
                ...new Set(
                    keys
                    .filter(p => p)
                    .sort((a, b) => {
                        // sort priorities like P0, P1, P2 numerically
                        let numA = parseInt(a.replace(/\D/g, '')) || 0;
                        let numB = parseInt(b.replace(/\D/g, '')) || 0;
                        return numA - numB;
                    })
                )
                ];

                // ✅ Reset all arrays & counts for this type before reassigning
                this[`set${upper}ListAll`] = [];
                keys.forEach(priority => {
                    let listProp = `set${upper}List${priority}`;
                    let countProp = `set${upper}Count${priority}`;
                    let flagProp = `set${upper}Count${priority}Flag`;

                    // Initialize reactivity if missing
                    if (!(listProp in this)) this.$set(this, listProp, []);
                    if (!(countProp in this)) this.$set(this, countProp, 0);
                    if (!(flagProp in this)) this.$set(this, flagProp, false);

                    // ✅ Reset existing data before filling
                    this[listProp] = [];
                    this[countProp] = 0;
                    this[flagProp] = false;
                });

                // Fill the lists dynamically
                keys.forEach(priority => {
                    let listProp = `set${upper}List${priority}`;
                    let countProp = `set${upper}Count${priority}`;
                    let flagProp = `set${upper}Count${priority}Flag`;

                    let items = Array.isArray(list[priority]) ? list[priority] : [];

                    this[countProp] = items.length;
                    this[flagProp] = items.length > 0;

                    if (items.length) {
                        this[listProp] = [...items];
                        this[`set${upper}ListAll`] = [...this[`set${upper}ListAll`], ...items];
                    }
                });

                // Calculate total counts
                let total = keys.reduce((acc, k) => acc + (Number(this[`set${upper}Count${k}`]) || 0), 0);

                if (!(`set${upper}CountAll` in this)) this.$set(this, `set${upper}CountAll`, 0);
                if (!(`set${upper}CountAllFlag` in this)) this.$set(this, `set${upper}CountAllFlag`, false);

                this[`set${upper}CountAll`] = total;
                this[`set${upper}CountAllFlag`] = total > 0;
            }
        },

        /** Return dynamic count */
        getCount(type, priority) {
            let key = `set${type.toUpperCase()}Count${priority}`;
            return this[key] || 0;
        },

        /** Return visibility flag */
        getFlagVisibility(type, priority) {
            let key = `set${type.toUpperCase()}Count${priority}Flag`;
            return this[key] || false;
        },

        /** Return active variant */
        getActiveVariant(type, priority) {
            let key = `activeTab${type.toUpperCase()}${priority}Flag`;
            return this[key] || 'outline-primary';
        },
    },
};


// WEBPACK FOOTER //
// ./src/views/components/newallocationpagev2/ReverseAllOFP/reverseallofp.js